/**
 * VariantHelper - Utility functions for variant calculations
 */
class VariantHelper {
    /**
     * Tính toán giá bán chính xác dựa trên variant và uom_id
     * @param {Object} variant - Object variant chứa thông tin giá
     * @param {number} uomId - ID của UOM cần tính giá
     * @returns {number} Giá bán chính xác cho UOM (kiểu int)
     */
    static calculateSellPriceForUom(variant, uomId) {
        // Nếu không có uomId hoặc variant không có sellpriceforuoms, trả về giá mặc định
        if (!uomId || !variant.sellpriceforuoms || !Array.isArray(variant.sellpriceforuoms)) {
            return parseInt(variant.sellprice) || 0;
        }

        // Tìm giá trong mảng sellpriceforuoms
        const uomPrice = variant.sellpriceforuoms.find(priceInfo => {
            return priceInfo.uom_id == uomId;
        });

        // Nếu tìm thấy giá cho UOM cụ thể, trả về giá đó
        if (uomPrice && typeof uomPrice.value === 'number') {
            return parseInt(uomPrice.value);
        }

        // Nếu không tìm thấy, trả về giá mặc định
        return parseInt(variant.sellprice) || 0;
    }
}

export default VariantHelper; 